import { laravelPost } from '../utils/laravelClient';
import { revokeLoyaltyToken } from './authApi';
import { loyaltySession } from '../utils/session';
import { markLoyaltyLoggedOut } from '../utils/loyaltySessionRestore';

/**
 * Request password reset email for loyalty user
 */
export async function requestPasswordReset(email) {
  return laravelPost('/loyalty/forgot-password', { email }, { auth: 'none' });
}

/**
 * Reset password using token from email
 */
export async function resetPassword({ email, token, password, password_confirmation }) {
  return laravelPost(
    '/loyalty/reset-password',
    { email, token, password, password_confirmation },
    { auth: 'none' },
  );
}

/** Revoke server session and clear local state. Returns immediately; API revoke is best-effort. */
export function logoutLoyalty() {
  markLoyaltyLoggedOut();
  loyaltySession.clear();
  return revokeLoyaltyToken();
}
